module.exports = __webpack_public_path__ + "templates.destination-section.family-mart-e3703cb3.html";